/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CRMVisualizationColumnResponse } from "./CRMVisualizationColumnResponse";
import type { PublicFieldView } from "./PublicFieldView";

/**
 * moved: written and confirmed in the column. needs_input: nothing was
 * written; fields lists the column's fields to ask about. not_moved:
 * nothing was written; message says why.
 */
export type CRMBoardMoveResponse = {
  status: CRMBoardMoveResponse.status;
  message?: string | null;
  fields?: Array<PublicFieldView> | null;
  columns?: Array<CRMVisualizationColumnResponse> | null;
};

export namespace CRMBoardMoveResponse {
  export enum status {
    MOVED = "moved",
    NEEDS_INPUT = "needs_input",
    NOT_MOVED = "not_moved",
  }
}
